import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import { setDisplayMenu } from '@/redux/app/appSlice';

import useMatchMedia from '@/hooks/useMatchMedia';

import closeImage from '@/images/close.svg';

import Portal from '@/ui/portal';

import Logo from '../logo';
import BtnProfile from '../btnProfile';
import Nav from '../nav';
import BtnSupport from '../btnSupport';
import BtnLogout from '../btnLogout';
import Copyright from '../copyright';

import s from './menu.module.css';

function Menu() {
  const dispatch = useDispatch();

  const [opened, setOpened] = useState(false);

  const handleClick = () => {
    if (isDesktop) return;

    setOpened(false);

    setTimeout(() => {
      dispatch(setDisplayMenu(false));
    }, 300);
  };

  useEffect(() => {
    setOpened(true);
  }, []);

  const { isMobile, isDesktop } = useMatchMedia();

  return (
    <Portal>
      <div className={s.backdrop} data-open={opened} onClick={handleClick}>
        <div className={s.menu} onClick={e => e.stopPropagation()}>
          <div className={s.menu_header}>
            <Logo />

            {!isDesktop && (
              <button
                type="button"
                className={s.btn_close}
                onClick={handleClick}
              >
                <img src={closeImage} alt="close" />
              </button>
            )}
          </div>

          <div className={s.scroll_wrapper}>
            {isMobile && <BtnProfile hideMenu={handleClick} />}
            <Nav />
            {isMobile && (
              <div className={s.menu_footer}>
                <BtnSupport />
                <BtnLogout />
                <Copyright />
              </div>
            )}
          </div>

          {!isMobile && (
            <div className={s.menu_footer}>
              <BtnSupport />
              <BtnProfile hideMenu={handleClick} />
              <Copyright />
            </div>
          )}
        </div>
      </div>
    </Portal>
  );
}

export default Menu;
